import * as React from "react";

const IconMenu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="rgba(0,0,0,0)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={0.6}
      className={"hb"}
      style={{
        cursor: "pointer",
      }}
      viewBox="0 0 10 10"
    >
      <path className="line1" d="M2 3h6" />
      <path className="line2" d="M2 5h6" />
      <path className="line3" d="M2 7h6" />
    </svg>
  );
};

export default IconMenu;
